import React from 'react';

// INTERFACES
import { ILoaderProps } from '../../interfaces/Loader.interface';

// STYLES
import { Container, LoaderSVG, GCircle1, GCircle2, GCircle3, GCircle4, Circle } from './styles';

const Loader: React.FC<ILoaderProps> = ({ isBlue }) => {
  return (
    <Container>
      <LoaderSVG className="loader" viewBox="0 0 48 48" width="48" height="48">
        <title style={{ visibility: 'hidden' }}>Carregando...</title>
        <GCircle1>
          <Circle r="2" stroke="none" strokeWidth="1" isBlue={isBlue} />
        </GCircle1>
        <GCircle2>
          <Circle r="2" stroke="none" strokeWidth="1" isBlue={isBlue} />
        </GCircle2>
        <GCircle3>
          <Circle r="2" stroke="none" strokeWidth="1" isBlue={isBlue} />
        </GCircle3>
        <GCircle4>
          <Circle r="2" stroke="none" strokeWidth="1" isBlue={isBlue} />
        </GCircle4>
      </LoaderSVG>
    </Container>
  );
};

export default Loader;
